import { Button, Form } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { Moment } from 'moment';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { absenceClient } from '../../../../core-module/services/absence/AbsenceClient';
import {
  AbsencePeriod,
  CreateReplacementRequest,
  Replacer
} from '../../../../core-module/services/absence/types';
import { ReplacementFormComponent } from './ReplacementFormComponent';
import { ReplacementFormValues } from './types';

interface OwnProps {
  readonly driverId: number;
  readonly absencePeriod: AbsencePeriod;
  readonly soonestAllowedAbsenceDate: Moment;
  readonly replacers: Replacer[];
  readonly onClose: () => void;
}

type Props = OwnProps & FormComponentProps<ReplacementFormValues>;

const ReplacementFormContainer: React.FC<Props> = ({
  form,
  driverId,
  absencePeriod,
  soonestAllowedAbsenceDate,
  replacers,
  onClose
}) => {
  const [saving, setSaving] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleSave = () => {
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        setSaving(true);

        const payload: CreateReplacementRequest = {
          date: values.date.toISOString(true),
          type: values.type,
          replacementDriverId: values.replacementDriverId,
          acquaintanceName: values.acquaintanceName,
          acquaintancePhoneNumber: values.acquaintancePhoneNumber
        };

        const promise = absenceClient.createReplacement(driverId, absencePeriod.id, payload);
        promise
          .then(() => {
            Swal({
              title: 'Vervanging opgeslagen',
              html: 'De vervanging is succesvol opgeslagen',
              type: 'success',
              confirmButtonText: 'Ok'
            }).then(() => {
              setVisible(false);
              onClose();
            });
          })
          .catch((err) => {
            Swal({
              title: 'Er is iets misgegaan',
              html: err.message,
              type: 'error',
              confirmButtonText: 'Ok'
            });
          })
          .finally(() => setSaving(false));
      }
    });
  };

  const onOpenFormClick = () => {
    setVisible(true);
  };

  if (!visible) {
    return (
      <Button type='link' onClick={onOpenFormClick} style={{ padding: 0 }}>
        Vervanging toevoegen...
      </Button>
    );
  }

  return (
    <ReplacementFormComponent
      form={form}
      absencePeriod={absencePeriod}
      soonestAllowedAbsenceDate={soonestAllowedAbsenceDate}
      replacers={replacers}
      saving={saving}
      onSave={handleSave}
    />
  );
};

const ReplacementFormContainerWithForm = Form.create<Props>()(ReplacementFormContainer);

export { ReplacementFormContainerWithForm as ReplacementFormContainer };
